export const statmentsData = [
  {
    questionNumber: 1,
    questionStatment: "I know myself… Spirit, Heart, Body, Mind, and Soul.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-awareness-YlevljgyZ8ig1rbN.jpg",
  },
  {
    questionNumber: 2,
    questionStatment:
      "I accept myself. I accept the infinite. I accept that I am infinite.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-infinite-being-AzGeL9grl5cVnGJO.jpg",
  },
  {
    questionNumber: 3,
    questionStatment: "I am connected as One with all aspects of the Universe.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-connectedness-A0xwOqzwW9hp0zky.jpg",
  },
  {
    questionNumber: 4,
    questionStatment:
      "I live harmoniously in balance with myself and all of Nature.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-balance-A0xwOqzwvGF2ELPX.jpg",
  },
  {
    questionNumber: 5,
    questionStatment:
      "I am living fully in the present moment, open to all possibilities.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-present-time-dJo6LVQ6bnSG445a.jpg",
  },
  {
    questionNumber: 6,
    questionStatment:
      "I am deeply connected with my Spirit energy, which protects and guides me.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-spirit-energy-mv0DBerDPDHVy628.jpg",
  },
  {
    questionNumber: 7,
    questionStatment:
      "I generate heart energy to experience greater love, joy, compassion, forgiveness, freedom and peace.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-heart-energy-m5KwEjzaqwcKrbeD.jpg",
  },
  {
    questionNumber: 8,
    questionStatment:
      "The stronger I make my body the more energy I can hold and emit.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-body-energy-Yyv3xBw1EphMDXDa.jpg",
  },
  {
    questionNumber: 9,
    questionStatment: "My mind is filled with positive thoughts.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-mind-energy-AR0yNZGX4jS4DMGX.jpg",
  },
  {
    questionNumber: 10,
    questionStatment: "I respect myself, everyone, and everything.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-respect-mePvEe9oO9Twg0yj.jpg",
  },
  {
    questionNumber: 11,
    questionStatment: "I continue to learn throughout my lifetime.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-lifelong-learner-mxBZO3JeXqIoXwJM.jpg",
  },
  {
    questionNumber: 12,
    questionStatment:
      "I rely on my wisdom to make conscious choices for my life.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-wisdom-YrDlZPx51airPeWo.jpg",
  },
  {
    questionNumber: 13,
    questionStatment: "I am fulfilled by serving my life purpose.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-life-purpose-m2WpngLXy4UVW1qN.jpg",
  },
  {
    questionNumber: 14,
    questionStatment:
      "I am open to, and accept, all changes that support my life purpose.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-change-dJo6L7vgbZHb5bqw.jpg",
  },
  {
    questionNumber: 15,
    questionStatment: "I accept what is, as it is, when it is.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-acceptance-mxBZO3JNNGFBOj5k.jpg",
  },
  {
    questionNumber: 16,
    questionStatment:
      "I live a heart-centered life, making heart-centered decisions.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-heart-centeredness-Y4LV5y7ByqIb8k19.jpg",
  },
  {
    questionNumber: 17,
    questionStatment:
      "I forgive myself and others, as we are all teachers for one another. Forgiveness is my path to freedom.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-forgiveness-AE0onV1wgnHLQekO.jpg",
  },
  {
    questionNumber: 18,
    questionStatment:
      "I am whole, fully embracing all Aspects of my Self, including my shadows.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-wholeness-ALpn5V6yD8cG7MJ1.jpg",
  },
  {
    questionNumber: 19,
    questionStatment: "I unconditionally love myself.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-self-love-d95KqvNevlupyXqj.jpg",
  },
  {
    questionNumber: 20,
    questionStatment: "I live my life with a pure and honest heart.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-honesty-A85wz3731nfZExyG.jpg",
  },
  {
    questionNumber: 21,
    questionStatment: "I inspire others by being my authentic self.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-authenticity-Y4LV5anyloU5a249.jpg",
  },

  {
    questionNumber: 22,
    questionStatment: "I live my truth, as it protects me.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-truth-m6LwGyKgPWTQnGR0.jpg",
  },
  {
    questionNumber: 23,
    questionStatment: "I trust myself and others.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-collaboration-Yg2WwexBJrcqloNE.jpg",
  },
  {
    questionNumber: 24,
    questionStatment: "I am clear and confident, humble and bold.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-confidence-ALpn5lkbGjSyge69.jpg",
  },
  {
    questionNumber: 25,
    questionStatment:
      "I experience inner peace as a result of doing my inner work.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-peacefulness-mk3z6EO8ROCNO8Zg.jpg",
  },
  {
    questionNumber: 26,
    questionStatment: "I surrender my personal will to Divine will.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-divine-will-ALpn5lkbXafaBOZz.jpg",
  },
  {
    questionNumber: 27,
    questionStatment:
      "I listen to the rhythm of my Soul. And I trust the Creator’s pace.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-patience-mePvENZLGOUq4Qax.jpg",
  },
  {
    questionNumber: 28,
    questionStatment: "I live my life with bravery.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-bravery-YBgrZBklbbHBVrpq.jpg",
  },
  {
    questionNumber: 29,
    questionStatment:
      "I will continue to persevere on my journey until I manifest my true heart’s desires and fulfill my life purpose.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-perseverance-AVLp8VkNR4FpLqn4.jpg",
  },
  {
    questionNumber: 30,
    questionStatment:
      "I am at peace with myself, and grateful in every area of my life.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-gratitude-mp8vD0En84Iv3DeM.jpg",
  },
  {
    questionNumber: 31,
    questionStatment: "I am humble and kind.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-humility-m5KwE79vgOCvxv4d.jpg",
  },
  {
    questionNumber: 32,
    questionStatment: "I live a simple life with very little drama.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-simplicity-AoPv2k5DOqFkZ4Pn.jpg",
  },
  {
    questionNumber: 33,
    questionStatment:
      "I work in collaboration with others to help fuel our collective success.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-collaboration-mjEvNWaQ6RU10oW2.jpg",
  },
  {
    questionNumber: 34,
    questionStatment:
      "With vision, every human challenge is possible to overcome.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-vision-YKb6j9kJNBSGyxGq.jpg",
  },
  {
    questionNumber: 35,
    questionStatment:
      "My focus inspires me to manifest my vision into reality.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-focus-YZ9VZ4kXJJC9wWbw.jpg",
  },
  {
    questionNumber: 36,
    questionStatment:
      "I contemplate my thoughts before I act, choosing to make decisions that support my life.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-contemplation-Yanyxj8z2NFoGRPr.jpg",
  },
  {
    questionNumber: 37,
    questionStatment: "I view everyone and everything as equals.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-equality-Yg2Wvxel23hWNQzb.jpg",
  },
  {
    questionNumber: 38,
    questionStatment:
      "I live my life with compassion for myself and others. I give to give, not give to get.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-compassion-m7Vwvo4kQPFX97LJ.jpg",
  },
  {
    questionNumber: 39,
    questionStatment:
      "I am an aspect of the togetherness that bonds our unified community.",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-unity-mxBZOkn8eGFPaXKD.jpg",
  },
  {
    questionNumber: 40,
    questionStatment: "I am free!",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-freedom-m5KwE79eXzCJ28Qo.jpg",
  },
  {
    questionNumber: 41,
    questionStatment:
      "I am fulfilled by giving to others. I am fulfilled by receiving from others.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-giving-receiving-mp8vD0EXD9FRrR5O.jpg",
  },
  {
    questionNumber: 42,
    questionStatment: "I live a prosperous life.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-prosperity-m5KwE79rL5FGpzyZ.jpg",
  },
  {
    questionNumber: 43,
    questionStatment:
      "I send thoughts of love, and love returns in overflowing measure.",
    userSelfRating: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-unconditional-love-A0xwOQJWqyIyxX1R.jpg",
  },
  {
    questionNumber: 44,
    questionStatment:
      "I live in harmony with Nature, for I am Nature. Conscious and regenerative living aligns with who I am.",
    userSelfRating: "",
    noResponse: "",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-conscious-regenerative-living-YZ9VZ4klkEFoKggj.jpg",
  },
];
